import { Action, Dispatch } from 'redux'
import { confirmBreadLabelsAction } from 'reducks/bread/actions'
import { BreadLabel } from 'types/bread'

const confirmBreadLabels = (breadLabels: BreadLabel[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(confirmBreadLabelsAction(breadLabels))
  }
}

export default confirmBreadLabels
